import uiRouter from "@uirouter/angularjs/lib-esm";
import angular from "angular";

import { default as userModuleName } from "../user";

import {
  vsComponentName as userPropertyComponentName,
  userPropertyComponentOptions,
  userPropertyComponentConfig,
} from "./components/user";

var deps = [
  uiRouter,
  "angularGrid",
  "SlotTrak.Utils",
  "ngSanitize",
  "SlotTrak.UI",
  userModuleName,
];

var mod = angular
  .module("SlotTrak.Properties", deps)
  .component(userPropertyComponentName, userPropertyComponentOptions)
  .config(userPropertyComponentConfig);

export default mod.name;
